export default function StorageKey(tenantId, key) {
    return `${tenantId}${key}`;
}
//# sourceMappingURL=StorageKey.js.map